import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';


type ConfirmDialogProps = {
    description?: React.ReactNode,
} & ModalActionProps;

const ConfirmDialog = ({description, onCancel, onFinish}: ConfirmDialogProps) => {
    const {t} = useTranslation();

    return (
        <Box>
            {description && (
                <DialogContent>
                    <DialogContentText>{description}</DialogContentText>
                </DialogContent>
            )}

            <DialogActions>
                <Button onClick={onCancel}>
                    {t('cancel')}
                </Button>
                <Button color="primary" onClick={onFinish}>
                    {t('ok')}
                </Button>
            </DialogActions>
        </Box>
    );
};

export default ConfirmDialog;
